<script>
import isFunction from 'lodash/isFunction';
import LocationModel from '@models/Location';
import BlockingContainer from '@components/BlockingContainer';
import editFormChange from '@mixins/editFormChange';

export default {
  components: {
    BlockingContainer,
  },
  mixins: [editFormChange],
  props: {
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    areas: {
      required: true,
      type: Array,
      default: null,
    },
    isModal: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      location: {
        name: null,
        area_id: null,
      },
      defaultLocation: {
        name: null,
        area_id: null,
      },
    };
  },
    mounted() {
    if (this.loadedId) {
      this.$wait.start('location loading');
      LocationModel.find(this.loadedId).then((response) => {
        this.location = Object.assign({}, this.location, response);
        this.$wait.end('location loading');
        this.$nextTick(() => {
          this.initChangeWatcher(['location'], this.validate);
        });
      });
    }
  },
  methods: {
    validate(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('location loading');
          this.submit(callback);
        }
      });
    },
    submit(callback) {
      if (this.$route.params.id && !this.isModal) {
        this.location.id = this.$route.params.id;
      }
      new LocationModel(this.location)
        .save()
        .then((response) => {
          this.location = response.location;
          this.$emit('submitted', response.location);
          if(!this.isModal) {
            if (callback && isFunction(callback)) callback();
          }
          this.$wait.end('location loading');
        })
        .catch(() => this.$wait.end('location loading'));
    },
  },
};
</script>

<template>
  <div>
    <BlockingContainer v-if="$wait.is('location loading')"></BlockingContainer>
    <b-form @submit.prevent="validate">
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12">
          {{ $t('fields.name') }}:
          <span class="status-star text-danger">*</span>
        </template>
        <b-form-input
          v-model="location.name"
          v-validate="'required|max:255'"
          data-vv-value-path="localValue"
          data-vv-name="name"
          :data-vv-as="$t('fields.name')"
          type="text"
          :state="errors.has('name') ? false : null"
          aria-describedby="input-feedback-name"
          :class="errors.has('name', 'location-form') ? 'is-invalid' : null"
          :placeholder="$t('placeholders.name')"
        >
        </b-form-input>
        <b-form-invalid-feedback id="input-feedback-name">
          <template v-show="errors.has('name')">{{ errors.first('name') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="$t('fields.area')">
        <b-form-select
              v-model="location.area_id"
              v-validate="'required'"
              data-vv-value-path="localValue"
              data-vv-name="area_id"
              :data-vv-as="$t('fields.area')"
              :state="errors.has('area_id', 'location-form') ? false : null"
              aria-describedby="input-feedback-area_id"
            >
              <option :value="null">{{ $t('placeholders.select_area') }}</option>
              <option v-for="area in areas" :key="`area${area.id}`" :value="area.id">
                {{ area.title }}
              </option>
            </b-form-select>
      </b-form-group>
      <b-button type="submit" :disabled="errors.any()" :variant="'outline-' + (!errors.any() ? 'dark' : 'danger')">
        {{ $t('actions.submit') }}
      </b-button>
    </b-form>
  </div>
</template>
